import React from "react";
import { Stack } from "@mantine/core";
import SurveyQuestion from "../services/model/SurveyQuestion";
import SurveyQuestionCard from "./SurveyQuestionCard";

type SurveySummaryResponsesStackProps = {
  items: SurveyQuestion[];
};

const SurveySummaryResponsesStack: React.FC<
  SurveySummaryResponsesStackProps
> = ({ items }) => (
  <Stack
    justify="flex-start"
    spacing="xl"
  >
    {items.map((it, index) => (
      <SurveyQuestionCard
        key={`question-${it.id}`}
        questionNumber={index + 1}
        question={it}
        total={items.length}
      />
    ))}
  </Stack>
);

export default SurveySummaryResponsesStack;
